export default {
  namespaced: true,
  grid: {
    widgets: {
      alarms: {
        incoming_alarms: {
          title: "Incoming Alarms"
        },
        alarms_being_attended: {
          title: "Attending Alarms"
        },
        alarms_in_attention: {
          title: "Attended Alarms"
        },
        pagination: {
          showing: "Showing",
          records: "Records",
          page: "Page",
          of: "of"
        },
        search: {
          placeholder: "Search by Alarm Id, Address, Tenant, Unit, Address..."
        },
        menu: {
          confirm: "Confirm",
          attended: "Attend",
          cancel: "Cancel",
          display: "Display",
          send_to_seproban: "Send to seproban",
          bau: "BAU",
          incidents: "Incidents",
          reports: "Reports"
        },
        table: {
          no_data: "No data available",
          restored_at: "Restored",
          rows: {
            1: "Alarm",
            2: "Device",
            3: "Facility",
            4: "Region",
            5: "Date"
          },
          popover: {
            alarm_id: "ID",
            alarm_type: "Alarm type",
            facility: "Facility",
            camera: "Device",
            date: "Date",
            taken_by: "Taken by",
            not_available: "N/A",
            local_hour: "Local Hour",
            central_hour: "Central Hour"
          }
        }
      },
      units: {
        title: "Facilities",
        messages: {
          no_data: "No data available"
        },
        pagination: {
          showing: "Showing",
          records: "Records",
          page: "Page",
          of: "of"
        },
        search: {
          placeholder: "Search by Unit, Address...",
          results: "Results",
          placeholderSearchUnits: "Search facility",
          placheholderMatches: "Search matches"
        },
        table: {
          rows: {
            1: "Name"
          }
        },
        subsystems_tree: {
          info: "Information",
          video: {
            title: "Video",
            live_video: "Live Video",
            recorded_video: "Recorded video",
            timeline: "Timeline",
          },
          voip: {
            make_call: 'Make a call',
          },
          activate_digital_output: "Activate digital output",
          disable_digital_output: "Disable digital output",
        }
      },
      layouts: {
        title: "Layouts"
      },
      views: {
        title: "Views"
      },
      widgets: {
        title: "Widgets"
      },
      charts: {
        title: "Charts",
        no_data: "No data available",
      },
      videowall: {
        title: "Videowall"
      },
      scripts: {
        title: "Scripts"
      },
    },
    modals: {
      alarms_status: {
        title_confirm: "Are You Sure To Send The Alarm?",
        title_attended: "Are you sure to end the alarm?",
        title_cancel: "Are You Sure To Cancel The Alarm?",
        protocol: 'Protocol',
        comments: "Comments",
        alarm_level: "Alarm level",
        btns: {
          send: "Send",
          cancel: "Cancel"
        },
        fromSameFacility: "From the same facility",
        fromSameAlarmType: "The same type of alarm",
        fromSameSector: "From the same sector"
      },
      update_layout: {
        cameras: "Cameras",
        pre_alarm: "Pre-Alarm",
        info: "Information",
        alarm_info: "Alarm info",
        unit_info: "Unit Information",
        plane: "Plano",
        unit_plane: "Show unit plan",
        map: "Map",
        alarm_location: "Alarm location",
        unit_location: "Unit location",
        gps: "gps",
        locations: "Locations",
        select_slot: "Select a slot",
        btns: {
          ok: "Ok"
        }
      }
    },
    tabs: {
      new_tab: "Add new tab",
      context_menu: {
        save_as_view: "Save as view",
        update_view: "Update View",
        update_name: "Update tab name"
      },
      alert: {
        title: "Tabs Alert",
        text: "The maximum number of allowed tabs is {max}."
      }
    },
    timeline: {
      waiting_for_main_camera: 'Waiting for main camera',
      no_footage_available: 'No footage available for the selected time',
      toolbar: {
        alarms: 'Alarms',
        objects: 'Objects',
        filter_type: 'Click to search for objects',
        zoom_in: 'Zoom In',
        zoom_out: 'Zoom out',
        x_seconds_fw: 'Forward 5 seconds',
        x_seconds_bw: 'Backward 5 seconds',
        play: 'Play',
        pause: 'Pause',
        synchronize: 'Synchronize',
        desynchronize: 'Desynchronize',
        download: 'Download',
        mostRecentEvent: 'Most recent event',
        speed: 'Speed',
        facialRecognitionEnrollment: 'Facial Recognition Enrollment',
      },
      objectsModal: {
        title: 'Search for objects',
        field1: {
          label: 'Provider'
        },
        field2: {
          label: 'Type'
        },
        field3: {
          label: 'From'
        },
        field4: {
          label: 'To'
        },
        field5: {
          label: 'Object'
        },
        operators: {
          equal_to: 'equal to',
          not_equal_to: 'not equal to',
          contains: 'contains',
          not_contains: 'does not contain',
          gt: 'greater than',
          lt: 'less than',
          gte: 'greater than or equal to',
          lte: 'less than or equal to',
          is_in: 'is in',
          is_not_in: 'is not in',
        }
      },
      downloadModal: {
        title: 'Download videos',
      },
    },
    frame: {
      url: 'url'
    },
    slots: {
      main: {
        messages: {
          widget_not_be_added: 'Widget could not be added',
          timeline_widget_exists: 'A widget of type Timeline already exists',
          chat_widget_exists: 'This chat has been already loaded',
          detection_event_widget_exists: 'A widget of type Detection event already exists',
          empty_text: 'Drag and drop cameras, map and widgets here'
        }
      },
      info: {
        unit: 'Facility',
        address: 'Address',
        actions: 'Actions',
        btns: {
          confirmed: 'Confirmed',
          attended: 'Attend',
          cancel: 'Cancel',
          reopen: 'Reopen alarm',
        },
        description: 'Description',
        company: 'Company',
        latitude: 'Latitude',
        longitude: 'Longitude',
        exterior_number: 'Exterior number',
        suburb: 'Suburb',
        municipality: 'Municipality',
        postal_code: 'Postal code',
        country: 'Country',
        region: 'Region',
        tracing: 'Logs',
        protocol: 'Protocol',
        attending_comments: 'Reason for attention',
        solved_comments: 'Reason for solution',
        cancel_comments: 'Reason for cancellation',
        status: 'Status',
        folio_cad: 'Folio CAD',
        data: 'Additional Info',
        camera: {
          review_start: 'Review start',
          review_end: 'Review end',
          events_review: 'Events review',
          center: 'Center',
          sector: 'Sector',
          previous_time: 'Previous time',
          later_time: 'Later time',
          reseller: {
            name: 'Name',
            company: 'Company'
          },
          bridge: {
            account_id: 'Account Id',
            bridge_id: 'Bridge Id',
            device_name: 'Device name'
          },
          bridge_account: {
            account_id: 'Account Id',
            name: 'Name'
          },
        },
        sip_call: {
          state: 'State',
          from: 'From',
          to: 'To',
          make_call: 'Call',
          origin_date: 'Origin Date',
          audio_record: 'Audio Record'
        },
        fr: {
          title: 'Face Recognition',
          enrolled_person: 'Enrolled person',
          face_detected: 'Face detected',
          detection: 'Detection',
          camera_name: 'Camera name',
          person_name: 'Person name',
          list_name: 'List name',
          age: 'Age',
          gender: 'Gender',
          emotion: 'Emotion',
          glasses: 'Use of glasses',
          picture_quality: 'Picture quality',
          blurriness: 'Blurriness',
          darkness: 'Darkness',
          brightness: 'Brightness',
          saturation: 'Saturation',
          score: 'Score',
          similarity: 'Similarity score',
          match_history: 'Match History',
          waiting_detection: "Waiting for detection",
          welcome: "Welcome",
          genderFemale: 'Femenino',
          genderMale: 'Masculino',
          similarity_score: 'Similarity score',
        },
        detection_events: {
          default: {
            title: 'Detection event'
          },
          lpr: {
            title: 'License plate recognition',
          },
          loitering: {
            title: 'Loitering',
          },
          crowded: {
            title: 'Crowded'
          },
          fr: {
            title: 'Face recognition',
          },
          people_counting: {
            title: 'People counting',
          },
          people_entering: {
            title: 'People entering',
          },
          people_exiting: {
            title: 'People exiting',
          },
          prohibited_parking: {
            title: 'Prohibited parking',
          },
          vehicle_count: {
            title: 'Vehicle count',
          },
          wrong_way: {
            title: 'Wrong way',
          },
          delimited_zone: {
            title: 'Delimited Zone',
          },
          person_fallen: {
            title: 'Person lying down',
          },
          smart_motion_detection: {
            title: 'Smart Motion Detection',
          },
          object_count: {
            title: 'Object Count',
          },
          person_in_area: {
            title: 'Person in area'
          },
          intrusion: {
            title: 'Intrusion'
          },
          tripwire: {
            title: 'Tripwire'
          },
          labels: {
            overall_picture: 'Overall picture',
            plate: 'Plate',
            camera_name: 'Camera name',
            city: 'City',
            date: 'Date',
            speed: 'Speed',
            brand: 'Brand',
            model: 'Modelo',
            color: 'Color',
            class: 'Class',
            list: 'List',
            confidence: 'Confidence',
          }
        },
        sip: {
          title: 'SIP Call',
          session_id: 'SessionId',
          state: 'State',
          from: 'From',
          to: 'To',
        },
        workflow_logs: {
          title: 'Workflows log',
          no_workflow_data: 'No workflow data available'
        },
        analytic_record: {
          title: 'Analytic Record',
          alarm_category: 'Alarm category',
          camera_name: 'Camera name',
          matched_rules: 'Matched rules',
          priority: 'Priority',
        },
        sensors: {
          title: 'Sensors',
          name: 'Name',
          type: 'Type',
          last_measurement: 'Last Measurement',
          measurement: 'Alarm Measurement',
          high_critical: 'Measurement High Critical',
          high_warning: 'Measurement High Warning',
          low_critical: 'Measurement Low Critical',
          low_warning: 'Measurement Low Warning',
        },
        emergency_contacts: "Emergency Contacts",
        no_emergency_contacts: "This unit has no emergency contacts",
        contact_info: {
          name: "Name",
          phone: "Phone",
          description: "Description"
        },
        general_summary: "General Summary",
        facility_detail: "Facility",
        risk_evaluation: "Risk Evaluation",
        cad_data: "C5 - CAD",
        institutions: "Institutions",
        alarm_groups: "Alarm Groups",
        smart_detection: "Smart Detection",
        lpr: "LPR",
        analytic_record_title: "Analytic Record",
        sip_calls: "SIP Calls",
        pbx_calls: "PBX Calls",
        mobotix: "Mobotix / ME",
        alarm_bridge_data: "Alarm Bridge Data",
        default_detection: "Detections",
        action_plan_log: "Action Plan Log",
        incident_log: "Incident Log",
        comments: "Comments",
        unit_title: "Unit",
        camera_title: "Camera",
        swift_sensor: "Swift Sensor",
        swift_sensor_tree: "Swift Sensor (Tree)",
        actuator: "Actuator",
        generic_device: "Generic Device",
        alarm_id: "Alarm ID",
        creation_date: "Creation Date",
        risk_percentage: "Risk percentage",
        cad_folio: "CAD Folio",
        answer_call: "Answer",
        copy_id: "Copy ID",
        copied: "Copied!",
        pdf_export: "Export PDF",
        no_comments_yet: "No comments yet",
        write_comment_here: "Write a comment here"
      },
      interphone: {
        type: 'Type',
        alarm: 'Alarm',
        created: 'Created',
        updated: 'Updated',
        user: 'User',
      }
    },
    widgets_section: {
      weather: {
        title: 'Weather',
        errorGeloocation: 'Could not get location',
        permissionDenied: 'Access to location was not allowed, please enable permissions on your device'
      },
      face_detection: {
        title: 'Face search',
      },
      map: {
        title: 'Map',
      },
      chart: {
        title: 'Chart',
      },
      detection_event: {
        title: 'Detection Event',
      },
      neo_dash: {
        title: 'Neo4j Reports',
        predefined_question: 'Predefined questions',
        cameras: 'Cameras',
        cameras_placeholder: 'Select one or more cameras',
        colors: 'Colors',
        colors_placeholder: 'Select one or more colors',
        time_range: 'Time range',
        last_days: 'Last {n} days',
        all_time: 'All history',
        plate_route_placeholder: 'Plate (e.g. ABC123)',
        min_speed_label: 'Minimum speed (km/h)',
        min_speed_placeholder: '50',
        window_seconds_label: 'Time window (seconds)',
        window_seconds_placeholder: '10',
        questions: {
          cars_by_day: 'How many cars passed per day?',
          cars_by_color: 'How many cars by color? (one graph per color)',
          cars_by_hour: 'At what hours do most/least cars pass?',
          cars_by_camera: 'How many cars has each camera detected?',
          vehicle_types: 'What vehicle types have passed?',
          vehicle_brands: 'What brands have passed?',
          top_plates: 'Top 10 most detected plates',
          plates_registered: 'How many plates are registered?',
          camera_flow: 'What are the most common routes between cameras?',
          plate_clones: 'Which plates look cloned or misread? (linked to more than one vehicle)',
          plate_route: 'Where did this plate travel?',
          over_speed: 'Which plates exceed the speed limit?',
          exposure_time: 'Which locations get the most traffic exposure time?',
          repeat_rate: 'What % of the audience is new vs. repeat?',
          new_vs_repeat_hour: 'At what hours does new vs. known audience dominate?',
          convoy: 'Which plates are detected together, seconds apart, on more than one camera?',
        },
        report: {
          detections: 'Detections',
          plate: 'Plate',
          vehicle: 'Vehicle',
          vehicles: 'Associated vehicles',
          empty: 'No data in the selected range',
          error: 'Could not load the report',
          no_plate_image: 'No image',
          no_detections: 'No detection details available for this plate',
          brand: 'Brand',
          type: 'Type',
          vehicle_color: 'Vehicle color',
          plate_color: 'Plate color',
          speed: 'Speed',
          direction: 'Direction',
          camera: 'Camera',
          date: 'Date',
          top_routes: 'Top routes through this camera',
          clone_alert: 'Possible clone: this plate is linked to more than one distinct vehicle',
          convoy_alert: 'Detected alongside another plate on more than one camera: possible convoy',
          convoy_partners: 'Travels with',
          convoy_partner_detail: '{plate} ({count}x across {cameras} cameras)',
          speeding_alert: 'Speeding: up to {speed} km/h recorded',
          avg_speed: 'Average speed',
          exposure_index: 'Exposure index',
          total_plates: 'Total plates',
          new_plates: 'New plates',
          repeat_plates: 'Repeat plates',
          repeat_rate: 'Repeat rate',
          business_hint: {
            cars_by_camera: 'Compare traffic across locations to justify differentiated billboard rates per site.',
            cars_by_day: 'Pick 90 days or All history to see the traffic growth trend and back up contract renewals.',
            cars_by_hour: 'Spot the busiest hours to decide when to rotate ads on digital screens.',
            vehicle_brands: 'The brand mix hints at the audience\'s buying power: useful for selling the spot to premium vs. mass-market brands.',
            vehicle_types: 'If commercial vehicles dominate, that location is a better fit for B2B or logistics brands.',
            exposure_time: 'The exposure index combines volume and average speed: the higher it is, the longer that audience sees the ad.',
            repeat_rate: 'Lots of new audience favors a discovery message; lots of repeat audience favors a brand-recall one.',
            new_vs_repeat_hour: 'Use this to decide which message to show on digital screens depending on the time of day.',
          },
          node_types: {
            camera: 'Cameras',
            plate: 'Plates',
            plate_clone: 'Plates (possible clone)',
            plate_speeding: 'Plates (speeding)',
            plate_convoy: 'Plates (traveling together)',
            vehicle: 'Vehicles',
          },
          chart_mode: {
            graph: 'Graph',
            bar: 'Bar',
            pie: 'Pie',
          },
          timeline: {
            show_all: 'Show all',
            up_to: 'Up to: {date}',
          },
        },
        color_names: {
          red: 'Red',
          green: 'Green',
          blue: 'Blue',
          white: 'White',
          black: 'Black',
          yellow: 'Yellow',
          gray: 'Gray',
          silver: 'Silver',
          orange: 'Orange',
          brown: 'Brown',
          beige: 'Beige',
          gold: 'Gold',
        },
        dashboard: {
          title: 'General summary',
          total: 'Detections',
          plates: 'Distinct plates',
          peak_hour: 'Peak hour',
          top_color: 'Most common color',
          range_all: 'All',
          detections: 'Detections',
          by_day: 'Detections per day',
          by_hour: 'Detections per hour',
          by_color: 'By color',
          by_type: 'By vehicle type',
          by_brand: 'By brand',
          by_camera: 'Detections per camera',
          error: 'Could not load the summary',
        },
        graph: {
          title: 'Trajectory graph',
          plate: 'Plate',
          plate_placeholder: 'Plate (empty = most detected)',
          error: 'Could not load the graph',
          lib_error: 'Could not load the graph library (NVL)',
        },
      },
    },
    saveLayout: {
      title: "Save layout",
      messages: {
        success: "Layout saved successfully",
        error: "Error saving layout"
      }
    },
    face_search: {
      title: 'Face Search Ntechlab',
    },
    add_slot: {
      title: 'Add Slot',
    }
  },
}
